import React from 'react'
import "./HomeFlags.css"
import HomeFlagsHead from './HomeFlagsHead'
import HomeFlagsMain from './HomeFlagsMain'
const HomeFlags = () => {
  return (
    <div className='HomeFlagsContainer'>
      <HomeFlagsHead/>
      <HomeFlagsMain/>
    </div>
  )
}

export default HomeFlags
